import { IconWrapper } from '../runtime';
export default IconWrapper('folder-cloud-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.75 20.25C1.50736 20.25 0.5 19.2426 0.5 18L0.5 3C0.5 1.75736 1.50736 0.75 2.75 0.75L7.25 0.75C7.73683 0.75 8.21053 0.9079 8.6 1.2L10.4 2.55C10.7895 2.8421 11.2632 3 11.75 3L22.25 3C23.4926 3 24.5 4.00736 24.5 5.25L24.5 18C24.5 19.2426 23.4926 20.25 22.25 20.25L2.75 20.25Z",
      "fill": "#317FF2"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.75 22.5C1.50736 22.5 0.5 21.4926 0.5 20.25L0.5 7.5C0.5 6.25736 1.50736 5.25 2.75 5.25L22.25 5.25C23.4926 5.25 24.5 6.25736 24.5 7.5L24.5 20.25C24.5 21.4926 23.4926 22.5 22.25 22.5L2.75 22.5Z",
      "fill": 'url(#' + props.id + '29fcb230' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10.3828 9.69532C11.5521 8.52604 13.4479 8.52604 14.6172 9.69532C15.7865 10.8646 15.7865 12.7604 14.6172 13.9297L14.5298 14.017L12.4127 11.8998C11.6643 11.1514 10.6995 10.7512 9.71973 10.6992C9.86586 10.3337 10.0869 9.99126 10.3828 9.69532ZM11.6172 12.6953C10.4479 11.526 8.5521 11.526 7.38282 12.6953C6.21354 13.8646 6.21354 15.7604 7.38282 16.9297C8.5521 18.0989 10.4479 18.0989 11.6172 16.9297L13.7343 14.8125L11.6172 12.6953ZM12.5001 17.6378L12.4127 17.7252C12.3831 17.7548 12.3531 17.7839 12.3228 17.8125H15.5001V17.8066C16.2663 17.8066 17.0326 17.5143 17.6172 16.9297C18.7865 15.7604 18.7865 13.8646 17.6172 12.6953C17.3213 12.3994 16.9788 12.1783 16.6134 12.0322C16.5613 13.012 16.1611 13.9767 15.4127 14.7252L15.3254 14.8125L12.5001 17.6378Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '29fcb230',
      "x1": "2.75",
      "y1": "6.43828",
      "x2": "19.6823",
      "y2": "24.658",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});